import { NavigateBackLink } from '@exam-management/components';
import { LOSDetails, LOSQuestionList } from '@exam-management/los-question-list';
import { useParams } from '@exam-management/router';
import { Box, Flex, PageHeader, Paper } from '@shared/components';

export default function QuestionsInLOSPage() {
  const { structureId, losId } = useParams('/qbank-structures/:structureId/los/:losId/questions');

  return (
    <Box>
      <PageHeader
        title='Questions in LOS'
        linkAdornment={
          <NavigateBackLink to='/qbank-structures/:structureId/los' params={{ structureId }} />
        }
      />
      <Flex sx={(theme) => ({ p: theme.spacing(6) })}>
        <Paper
          sx={(theme) => ({
            display: 'flex',
            flexDirection: 'column',
            p: theme.spacing(6),
            gap: theme.spacing(6),
            width: '100%',
          })}
        >
          <LOSDetails losId={losId} />
          <LOSQuestionList losId={losId} structureId={structureId} />
        </Paper>
      </Flex>
    </Box>
  );
}
